import { z } from 'zod';
import { ProjectPositionNumberSchema, POSITION_STATUS_SCHEMA } from '@schuettflix/interfaces';
import { ProductConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { FinanceSettingsSchema } from '@/shared/models/ContextDataModel/interfaces/entities/finance-settings.ts';
import { PositionConfigurationSchema } from '@/shared/models/ContextDataModel/interfaces/position/position-configuration.ts';

const GetFinanceSettingsSchema = FinanceSettingsSchema;

export const GetProductConfigurationSchema = z.object({
    ...ProductConfigurationSchema.shape,
    id: z.string().uuid(),
    reservedQuantity: z.number().nonnegative(),
    fulfilledQuantity: z.number().nonnegative(),
});

export const GetPositionConfigurationResponseSchema = z.object({
    ...PositionConfigurationSchema.omit({ projectNumber: true }).shape,
    id: z.string().uuid(),
    note: z
        .string()
        .nullable()
        .transform(val => val ?? undefined),
    number: ProjectPositionNumberSchema,
    productConfigurations: z.array(GetProductConfigurationSchema),
    createdBy: z.number().nullable(),
    financeSettings: z.array(GetFinanceSettingsSchema),
    status: POSITION_STATUS_SCHEMA,
    orderCount: z.number(),
});

export type GetPositionConfigurationResponse = z.infer<typeof GetPositionConfigurationResponseSchema>;
